import LoginType from '../constants/LoginType';
import UserRole from '../constants/UserRole';

export const getUnitCategoryName = (unit, slug, depth, defaultName = '-') => {
	if (!unit) return '-';

	let categoryBySlug = unit.categories?.find((category) => category.slug === slug);
	let categoryItemByDepth = categoryBySlug?.category_items.find((categoryItem) => categoryItem.depth === depth);
	return categoryItemByDepth?.name ?? defaultName;
};

export const getCategoryFilterTitle = (categoryFilter, slug, depth) => {
	if (categoryFilter.length === 0) return '';
	let filter = categoryFilter
		.find((category) => category.slug === slug)
		.filters.find((categoryFilter) => categoryFilter.depth === depth);
	return filter.title;
};

export const convertDateToStr = (date) => {
	if (date === null) return null;

	return (
		`${date ? date.getFullYear() : '-'}`.padStart(2, '0') +
		'-' +
		`${date ? date.getMonth() + 1 : '-'}`.padStart(2, '0') +
		'-' +
		`${date ? date.getDate() : '-'}`.padStart(2, '0')
	);
};

export const getUserLoginStr = (user) => {
	if (user.login_type === LoginType.COMMON) {
		return user.user_login;
	}

	if (user.user_login.indexOf('gn') === 0) {
		return user.user_login.substring(2);
	}

	return user.user_login;
};

export const checkRoomAdminRole = (user, unitId) => {
	if (!user) {
		return false;
	}

	// 전체 관리자
	if (user && UserRole.isSystemAdminRole(user.user_role)) {
		return true;
	}

	// 시설 관리자
	if (user && UserRole.isRoomAdminRole(user.user_role)) {
		return true;
	}

	// 예약 항목 관리자
	if (user && UserRole.isTargetRoomUnitAdmin(user.user_role, user.unit_admins, unitId)) {
		return true;
	}

	return false;
};

export const checkProductAdminRole = (user, unitId) => {
	if (!user) {
		return false;
	}

	// 전체 관리자
	if (user && UserRole.isSystemAdminRole(user.user_role)) {
		return true;
	}

	// 시설 관리자
	if (user && UserRole.isProductAdminRole(user.user_role)) {
		return true;
	}

	// 예약 항목 관리자
	if (user && UserRole.isTargetProductUnitAdmin(user.user_role, user.unit_admins, unitId)) {
		return true;
	}

	return false;
};

export const checkConsultAdminRole = (user, unitId) => {
	if (!user) {
		return false;
	}

	// 전체 관리자
	if (user && UserRole.isSystemAdminRole(user.user_role)) {
		return true;
	}

	// 상담 관리자
	if (user && UserRole.isConsultAdminRole(user.user_role)) {
		return true;
	}

	// 예약 항목 관리자
	if (user && UserRole.isTargetConsultUnitAdmin(user.user_role, user.unit_admins, unitId)) {
		return true;
	}

	return false;
};

/**
 * 사용자의 선택한 날짜가 예약 신청 가능한 날짜가 맞는지 확인한다.
 * @param {Date} selectedDate 사용자가 선택한 날짜
 * @param {string} enableRequestDay 예약 신청 가능한 최대 일
 */
export const checkAvailableBookingDate = (selectedDate, enableRequestDay) => {
	// 오늘 날짜의 시작시간을 기준으로 날짜를 비교한다.
	const nowDate = new Date();
	nowDate.setHours(0);
	nowDate.setMinutes(0);
	nowDate.setSeconds(0);

	// 선택한 날짜는 UTC 시간 기준으로 되어 있으므로 시간을 0으로 맞춘다.
	const startOfBookingDate = new Date(selectedDate);
	startOfBookingDate.setHours(0);

	// 두 날짜의 차이를 구한다.
	const oneDay = 1000 * 60 * 60 * 24;
	const diffInTime = startOfBookingDate.getTime() - nowDate.getTime();
	const diffInDays = Math.round(diffInTime / oneDay);

	// 두 날짜 차이를 기준으로 예약 가능여부를 판단한다.
	if (diffInDays < enableRequestDay) {
		return false;
	}

	return true;
};

/**
 * 예약한 날짜가 취소 가능한 날짜가 맞는지 확인한다.
 * @param {Date} bookingDate 예약한 날짜
 * @param {string} enableCancelDay 예약 취소 가능한 최대 일
 */
export const checkCancellableBookingDate = (bookingDate, enableCancelDay) => {
	// 오늘 날짜의 시작시간을 기준으로 날짜를 비교한다.
	const nowDate = new Date();
	nowDate.setHours(0);
	nowDate.setMinutes(0);
	nowDate.setSeconds(0);

	// 선택한 날짜는 UTC 시간 기준으로 되어 있으므로 시간을 0으로 맞춘다.
	const startOfBookingDate = new Date(bookingDate);
	startOfBookingDate.setHours(0);

	// 두 날짜의 차이를 구한다.
	const oneDay = 1000 * 60 * 60 * 24;
	const diffInTime = startOfBookingDate.getTime() - nowDate.getTime();
	const diffInDays = Math.round(diffInTime / oneDay);

	// 두 날짜 차이를 기준으로 예약 가능여부를 판단한다.
	if (diffInDays < enableCancelDay) {
		return false;
	}

	return true;
};
/**
 * 텍스트에 있는 링크를 <a>로 감싸 하이퍼링크가 가능한 html로 변환해준다.
 * @param {string} text
 */
export const convertTextToLink = (text) => {
	const urlRegex = new RegExp(/(https?:\/\/[^\s]+)/, 'g');
	const convertLink = text.replace(urlRegex, (url) => {
		return '<a href="' + url + '" target="_blank">' + url + '</a>';
	});

	return { __html: convertLink };
};
